import axios from "axios";

class InvestorService {
    customers(payload){
        let url = `investor/customers?page=${payload.page}&page_size=${payload.size}&search=${payload.search}&date_from=${payload.date_from}&date_to=${payload.date_to}`;
        return axios.get(url)
            .then((response) => {
                return response.data;
            })
    }

    packages(payload){
        let url = `investor/packages?page=${payload.page}&page_size=${payload.size}&search=${payload.search}&date_from=${payload.date_from}&date_to=${payload.date_to}`;
        return axios.get(url)
            .then((response) => {
                return response.data;
            })
    }

    payments(payload){
        let url = `investor/payments?page=${payload.page}&page_size=${payload.size}&search=${payload.search}&date_from=${payload.date_from}&date_to=${payload.date_to}`;
        return axios.get(url)
            .then((response) => {
                return response.data;
            })
    }

}

export default new InvestorService();

